import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

import {LeadStatus} from "./ILeadStatus";

export enum HomeMatchPreleadStatus {
    PENDING = 1,
    REJECTED = 2,
    ACCEPTED = 3
}

export const getHomeMatchPreleadStatusLabel = (status: HomeMatchPreleadStatus | LeadStatus) => {
    switch (status) {
        case HomeMatchPreleadStatus.PENDING:
            return "oczekująca";
        case HomeMatchPreleadStatus.REJECTED:
        case LeadStatus.REJECTED:
            return "odrzucona";
        case HomeMatchPreleadStatus.ACCEPTED:
            return "zaakceptowana";
        case LeadStatus.SENT:
            return "wysłana";
        default:
            notifyBugsnagClient(
                {message: "Invalid home match prelead status", filename: "IHomeMatchPrelead.ts"},
                "getHomeMatchPreleadStatusLabel: unknown status"
            );
            return undefined;
    }
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

import {LeadStatus} from "./ILeadStatus";

export enum HomeMatchPreleadStatus {
    PENDING = 1,
    REJECTED = 2,
    ACCEPTED = 3
}

export const getHomeMatchPreleadStatusLabel = (status: HomeMatchPreleadStatus | LeadStatus) => {
    switch (status) {
        case HomeMatchPreleadStatus.PENDING:
            return "oczekująca";
        case HomeMatchPreleadStatus.REJECTED:
        case LeadStatus.REJECTED:
            return "odrzucona";
        case HomeMatchPreleadStatus.ACCEPTED:
            return "zaakceptowana";
        case LeadStatus.SENT:
            return "wysłana";
        default:
            notifyBugsnagClient(
                {message: "Invalid home match prelead status", filename: "IHomeMatchPrelead.ts"},
                "getHomeMatchPreleadStatusLabel: unknown status"
            );
            return undefined;
    }
};
